import moment from "moment";
import objectPath from "object-path";
import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";
import datetimeHelper from "../../helper/datetime-helper";

export const GET_LIST_REPORT_QUANTITY = "GET_LIST_REPORT_QUANTITY";
export const GET_LIST_REPORT_QUANTITY_ERROR = "GET_LIST_REPORT_QUANTITY_ERROR";
export const GET_LIST_REPORT_QUANTITY_SUCCESS =
  "GET_LIST_REPORT_QUANTITY_SUCCESS";

const initialState = {
  report: [],
  error: false,
  loading: false,
};

export const reportQuantityReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_REPORT_QUANTITY:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_REPORT_QUANTITY_SUCCESS:
      return {
        ...state,
        loading: false,
        report: action.payload,
      };
    case GET_LIST_REPORT_QUANTITY_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListReportQuantity = (phone, from, to, type) => ({
  type: GET_LIST_REPORT_QUANTITY,
  data: {
    phone,
    from,
    to,
    type,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListReportQuantity,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListReportQuantityApi = (number, from, to, type) => {
  return apiCaller.getData("/cloud-pbx/inbound-call/quantity-report", {
    from,
    to,
    number,
    type,
  });
};

/**
 * sagas
 */

export const getListReportTicketFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_REPORT_QUANTITY);
    try {
      const res = yield call(
        getListReportQuantityApi,
        action.data.phone,
        action.data.from,
        action.data.to,
        action.data.type
      );
      const data = res.data.sort(function (a, b) {
        var n =
          Date.parse(moment(b.date, "DD-MM-YYYY").format("YYYY-MM-DD")) -
          Date.parse(moment(a.date, "DD-MM-YYYY").format("YYYY-MM-DD"));
        if (n != 0) {
          return n;
        }
        return ("" + a.number).localeCompare(b.number);
      });

      const reportGroups = {
        date: {
          fields: ["date"],
        },
      };

      data.forEach((item) => {
        item.groups = {};
        // if (action.data.type === 'inbound') {
        //     item.duration = datetimeHelper.hhmmss(item.answeredDuration)
        // } else if (action.data.type === 'outbound') {
        //     item.duration = datetimeHelper.hhmmss(item.duration)
        // } else {
        //     if (item.type === 'Gọi ra') {
        //         item.duration = datetimeHelper.hhmmss(item.duration)
        //     } else if (item.type === 'Gọi vào') {
        //         item.duration = datetimeHelper.hhmmss(item.answeredDuration)
        //     } else {
        //         item.duration = datetimeHelper.hhmmss(item.duration)
        //     }
        // }
        item.duration = datetimeHelper.hhmmss(item.duration);

        for (const groupName in reportGroups) {
          if (reportGroups.hasOwnProperty(groupName)) {
            let foundItemsInGroup = data.filter((i) => {
              let reportGroup = reportGroups[groupName];
              let condition = true;
              if (reportGroup) {
                reportGroup.fields.forEach((field) => {
                  condition &=
                    objectPath.get(i, field) === objectPath.get(item, field);
                });
              }
              return condition;
            });
            let indexInGroup = foundItemsInGroup.indexOf(item);

            item.groups[groupName] = {
              index: indexInGroup,
              count: foundItemsInGroup.length,
            };
          }
        }
        if (!item.number) {
          item.number = "Total";
        }
      });
      data.unshift(data.pop());
      yield put({
        type: GET_LIST_REPORT_QUANTITY_SUCCESS,
        payload: { ...data },
      });
    } catch (error) {
      yield put({ type: GET_LIST_REPORT_QUANTITY_ERROR, error });
    }
  }
};
